import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { APP_ASSET_VERSION } from './app/core/app-asset-version';

const currentVersion = APP_ASSET_VERSION;

async function clearServiceWorkerCaches(): Promise<boolean> {
  let hadServiceWorker = false;

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    hadServiceWorker = registrations.length > 0;
    await Promise.all(
      registrations.map((registration) => registration.unregister()),
    );
  }

  if ('caches' in window) {
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map((key) => caches.delete(key)));
  }

  return hadServiceWorker;
}

async function bootstrap(): Promise<void> {
  // Service worker desactivado: eliminamos cualquier registro/caché previo para
  // liberar a los usuarios que ya lo tenían instalado (env.js y bundles viejos).
  const hadServiceWorker = await clearServiceWorkerCaches();

  const storedVersion = localStorage.getItem('currentVersion');
  if (storedVersion !== currentVersion) {
    const savedLang = localStorage.getItem('preferredLanguage');

    localStorage.clear();
    localStorage.setItem('currentVersion', currentVersion);
    if (savedLang) {
      localStorage.setItem('preferredLanguage', savedLang);
    }
  }

  if (hadServiceWorker) {
    // Había un SW sirviendo archivos cacheados: recargamos una sola vez para
    // obtener los assets frescos ya sin service worker de por medio.
    window.location.reload();
    return;
  }

  await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrap().catch((err) => console.error(err));
